export const githubUrl = "https://github.com/HarryHighPants/SpeedCardGame"
